<template>
  <div>
    <div v-if="agentUploadErr" style="margin:40px 24px;text-align:center;">
      点击右上角分享至微信打开页面
    </div>
    <div v-else-if="exceed && isCampusManaQrcode">
      <p class="exceed-text">该二维码已失效，不可投递简历</p>
    </div>
    <div style="margin-top: 2em;" v-else>
      <div v-if="inBlackList" style="" class="blacklist-warring">
        <img
          src="../../public/img/balcklist-warring-with-wechat.png"
          alt="提交成功"
        />
      </div>
      <a-row type="flex" justify="center" v-else>
        <a-col :span="21">
          <!-- <a-button class="recommend"
            ><a :href="growthUrl">推荐拿奖金</a>
          </a-button> -->
          <div class="logo-block-wrap">
            <img
              src="@/assets/tutor-logo.svg"
              alt=""
              v-if="'iconlogo' === logoName"
              style="height:.4rem"
            />
            <garden-icon :type="logoName" style="font-size: .4rem" v-else />
            <span
              style="font-size: .24rem;vertical-align: text-bottom;margin-left: 0.5em;"
              >{{ department }}招聘</span
            >
          </div>
          <div style="margin-top: 1em">
            <a-spin tip="Loading..." v-bind:spinning="loadingResume">
              <a-form :layout="'horizontal'" style="padding-bottom:60px">
                <a-form-item
                  label="*城市"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-select
                    default-value="1"
                    v-model="city"
                    @change="change('city')"
                  >
                    <a-select-option
                      v-for="city in citys"
                      :value="city.id"
                      :key="city.id"
                      >{{ city.name }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="*应聘职位"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-select
                    default-value="1"
                    v-model="position"
                    v-bind:class="{ error: checkFlag.position == true }"
                    @change="change('position')"
                  >
                    <a-select-option
                      v-for="job in jobs"
                      :value="job.positionId"
                      :key="job.positionId"
                      >{{ job.positionName }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="上传简历附件"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-upload
                    :multiple="false"
                    class="uploads"
                    :fileList="fileList"
                    :beforeUpload="beforeUpload"
                    :remove="handleRemove"
                    :disabled="resumeButtonDisabled"
                  >
                    <a-button class="btn-default" block>{{
                      resumeButtonTitle
                    }}</a-button>
                    <p class="tip">
                      支持WORD、PDF、PNG、JPG、JPEG、WPS等格式文件的上传(简历小于10M)
                    </p>
                  </a-upload>
                </a-form-item>
                <a-form-item
                  label="*姓名"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-input
                    v-model="modelData.name"
                    v-bind:class="{ error: checkFlag.name == true }"
                    @change="change('name')"
                  />
                </a-form-item>
                <a-form-item
                  label="年龄"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-input type="number" v-model="modelData.age" />
                </a-form-item>
                <a-form-item
                  label="*学校"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-input
                    v-model="modelData.educations[0].university"
                    v-bind:class="{ error: educationFlag.university == true }"
                    @change="changeEducation('university')"
                  />
                </a-form-item>
                <a-form-item
                  label="学历"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-select
                    v-model="modelData.educations[0].degree"
                    v-bind:class="{ error: educationFlag.degree == true }"
                    @change="changeEducation('degree')"
                  >
                    <a-select-option
                      v-for="degree in degrees"
                      :value="degree"
                      :key="degree"
                      >{{ degree }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="*专业"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-input
                    v-model="modelData.educations[0].major"
                    v-bind:class="{ error: educationFlag.major == true }"
                    @change="changeEducation('major')"
                  />
                </a-form-item>
                <a-form-item
                  label="*联系电话"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-input
                    v-model="modelData.phone"
                    v-bind:class="{ error: checkFlag.phone == true }"
                    @change="change('phone')"
                  />
                </a-form-item>
                <a-form-item
                  label="*邮箱"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-input
                    v-model="modelData.mail"
                    v-bind:class="{ error: checkFlag.mail == true }"
                    @change="change('mail')"
                  />
                </a-form-item>
                <a-form-item
                  label="是否统招"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-select v-model="modelData.educations[0].unifiedAdmission">
                    <a-select-option
                      v-for="unifiedAdmission in unifiedAdmissions"
                      :value="unifiedAdmission.value"
                      :key="unifiedAdmission.value"
                      >{{ unifiedAdmission.name }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="在校起止时间"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-row type="flex" justify="start">
                    <a-col :span="11"
                      ><a-month-picker
                        v-model="modelData.educations[0].startDate"
                        placeholder="在校开始时间"
                        style="width: 100%;"
                        v-bind:class="{
                          error: educationFlag.startDate == true,
                        }"
                        @change="changeEducation('startDate')"
                      >
                      </a-month-picker
                    ></a-col>
                    <a-col :span="2" style="text-align: center;">–</a-col>
                    <a-col :span="11"
                      ><a-month-picker
                        v-model="modelData.educations[0].endDate"
                        placeholder="在校结束时间"
                        style="width: 100%;"
                        v-bind:class="{ error: educationFlag.endDate == true }"
                        @change="changeEducation('endDate')"
                      >
                      </a-month-picker
                    ></a-col>
                  </a-row>
                </a-form-item>
                <!--               <a-form-item
                label="教师资格证"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <a-select
                  default-value="1"
                  v-model="modelData.hasTeacherCertificate"
                >
                  <a-select-option
                    v-for="teacher in teacherCertificates"
                    :value="teacher.value"
                    :key="teacher.value"
                    >{{ teacher.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item
                label="英语资格证"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <a-select v-model="modelData.englishLevel">
                  <a-select-option
                    v-for="english in englishLevels"
                    :value="english"
                    :key="english"
                    >{{ english }}</a-select-option
                  >
                </a-select>
              </a-form-item> -->
                <a-form-item
                  label="*渠道"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                  v-show="keyfrom != 'wx-recommend' && channelShowAll"
                >
                  <a-select
                    v-model="channelJson.channel"
                    @change="changeChannel('channel')"
                    v-bind:class="{ error: channelFlag.channel == true }"
                  >
                    <a-select-option
                      v-for="(value, key) in channels"
                      :value="key"
                      :key="key"
                      >{{ key }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="*二级渠道"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                  v-show="channelShowAll && sceChannels.length > 0"
                >
                  <a-select
                    v-model="channelJson.secChannelId"
                    @change="changeChannel('secChannelId')"
                    showSearch
                    :filterOption="filterOption"
                    v-bind:class="{ error: channelFlag.secChannelId == true }"
                  >
                    <a-select-option
                      v-for="sceChannel in sceChannels"
                      :value="sceChannel.secChannelId"
                      :key="sceChannel.secChannelId"
                      >{{ sceChannel.name }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="*双选会/宣讲会学校"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                  v-show="
                    channelShowAll &&
                      schoolRecruitmentSecChannelIds.includes(
                        channelJson.secChannelId,
                      )
                  "
                >
                  <a-input
                    v-model="channelJson.channelSchool"
                    @change="changeChannel('channelSchool')"
                    v-bind:class="{ error: channelFlag.channelSchool == true }"
                  />
                </a-form-item>
                <a-form-item
                  label="*内推人"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                  v-show="channelShowAll && channelJson.channel === '内推'"
                >
                  <a-input
                    v-model="channelJson.recommand"
                    @change="changeChannel('recommand')"
                    v-bind:class="{ error: channelFlag.recommand == true }"
                  />
                </a-form-item>
                <a-form-item
                  label="*推荐人姓名"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                  v-show="channelShowAll && channelJson.channel === '外部推荐'"
                >
                  <a-input
                    v-model="channelJson.outerRecommand"
                    @change="changeChannel('outerRecommand')"
                    v-bind:class="{ error: channelFlag.outerRecommand == true }"
                  />
                </a-form-item>
                <a-form-item
                  label="*推荐人手机号"
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                  v-show="channelJson.channel === '外部推荐'"
                >
                  <a-input
                    v-model="channelJson.outerRecommandMobile"
                    @change="changeChannel('outerRecommandMobile')"
                    v-bind:class="{
                      error: channelFlag.outerRecommandMobile == true,
                    }"
                  />
                </a-form-item>
                <a-affix :offsetBottom="0">
                  <a-form-item style="background: #fff;margin-bottom:0px">
                    <a-button
                      style="float: right;margin:10px 0"
                      class="btn-submit"
                      @click="handleOk"
                    >
                      提交</a-button
                    >
                  </a-form-item>
                </a-affix>
              </a-form>
            </a-spin>
          </div>
        </a-col>
      </a-row>
      <a-modal
        :visible="visible"
        :footer="null"
        :closable="false"
        :maskClosable="false"
        wrapClassName="success-modal-wrap"
        width="80vw"
      >
        <img
          src="../../public/img/delivery-success-with-wechat.png"
          alt="提交成功"
        />
      </a-modal>
    </div>
  </div>
</template>
<script type="text/javascript">
import message from 'ant-design-vue/lib/message'
import {
  getDegree,
  getEnglishLevel,
  parseResume,
  schoolUploadResume,
  getDeptCity,
  getDeptPositionNew,
  isMobile,
  isEmail,
  compareTime,
  uploadTutorResume,
  getResumeChannels,
  checkBlackList,
  checkQrCodeStatus,
} from '@/service/resume'
import moment from 'moment'
import { growthUrl } from '@/service/request'
export default {
  data() {
    return {
      growthUrl,
      channels: {},
      sceChannels: [],
      modelData: {
        gender: '未知', //
        age: '', //
        name: '', //
        mail: '', //
        phone: '', //
        hasTeacherCertificate: 0, //
        englishLevel: '未知', //
        cityName: '', //
        educations: [
          {
            degree: '未知',
            dept: '',
            endDate: null,
            major: '',
            startDate: null,
            unifiedAdmission: 1,
            university: '',
            universityLevel: '未知',
          },
        ],
        positionName: '', //
      },
      checkFlag: {
        name: false,
        mail: false,
        phone: false,
        englishLevel: false,
        position: false,
      },
      educationFlag: {
        major: false,
        university: false,
        unifiedAdmission: false,
        startDate: false,
        endDate: false,
        degree: false,
      },
      channelJson: {
        channel: '',
        secChannelId: '',
        recommand: '',
        channelSchool: '',
        uploaderLdap: '',
        outerRecommand: '',
        outerRecommandMobile: '',
      },
      channelFlag: {
        channel: false,
        secChannelId: false,
        recommand: false,
        channelSchool: false,
        outerRecommand: false,
        outerRecommandMobile: false,
      },
      city: 0,
      citys: [{ id: 0, name: '请选择' }],
      position: 0,
      jobs: [{ id: 0, name: '请选择' }],
      fileList: [],
      degrees: [],
      englishLevels: [],
      resumeButtonTitle: '上传简历',
      resumeButtonDisabled: false,
      loadingResume: false,
      department: '猿辅导',
      product: this.$route.params.product,
      teacherCertificates: [{ name: '有', value: 1 }, { name: '无', value: 0 }],
      unifiedAdmissions: [{ name: '是', value: 1 }, { name: '否', value: 0 }],
      visible: false,
      logoName: '',
      acceptFileType: [
        'application/msword',
        'image/jpeg',
        'application/pdf',
        'image/png',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ],
      urlQuery: {},
      keyfrom: 'xx-qrcode',
      userId: '',
      channelShowAll: true,
      inBlackList: false,
      schoolRecruitmentSecChannelIds: [5, 6], // 宣讲会、双选会
      exceed: false,
    }
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
      }
    },
    buttonItemLayout() {
      return {
        wrapperCol: { span: 4, offset: 18 },
      }
    },
    agentUploadErr() {
      return this.$store.state.agentUploadErr
    },
    isCampusManaQrcode() {
      const { id } = this.$route.query
      return !!id
    },
  },
  async created() {
    await this.checkQrCodeStatus()
    this.inBlackList = await this.backListValidate()
    if (!this.inBlackList) {
      this.resoveKeyfrom()
      this.frogReport('/event/submitResume/pageView')
      if (this.product === 'tutor') {
        this.department = '猿辅导'
        this.logoName = 'iconlogo'
      } else if (this.product === 'banma') {
        this.department = '斑马'
        this.logoName = 'iconbanma'
      } else {
        this.department = '猿辅导'
        this.logoName = 'iconlogo'
      }
      this.degreeData()
      this.englishLevelData()
      this.queryCity()
      this.channels = await getResumeChannels()
    }
  },
  methods: {
    async checkQrCodeStatus() {
      if (!this.isCampusManaQrcode) return
      const { id, sc } = this.$route.query
      if (id && isNaN(Number(sc))) {
        return (this.exceed = true)
      }
      const query = {
        id,
        secChannelId: Number(sc),
      }
      this.exceed = await checkQrCodeStatus(query)
    },
    async backListValidate() {
      const { web_keyfrom } = this.$route.query
      if (web_keyfrom) {
        const userId = web_keyfrom.split('wx-recommend-')[1]
        if (userId) {
          let res = await checkBlackList(userId)
          return res
        }
        return false
      }
      return false
    },
    async queryCity() {
      this.citys = [{ id: 0, name: '请选择' }]
      try {
        let citys = await getDeptCity({ depart: this.department })
        this.citys = this.citys.concat(citys)
      } catch {}
    },
    async queryPosition() {
      this.jobs = [{ id: 0, name: '请选择' }]
      try {
        const query = {
          cityId: this.city,
          recruitmentWebsiteId: this.department === '猿辅导' ? 1 : 2,
          flag: 0,
          type: '',
          teachType: '11',
          positionName: '',
        }
        let positions = await getDeptPositionNew(query)
        this.jobs = this.jobs.concat(positions)
      } catch {}
    },
    degreeData() {
      getDegree().then(res => (this.degrees = res))
    },
    englishLevelData() {
      getEnglishLevel().then(res => (this.englishLevels = res))
    },
    async handleOk() {
      this.frogReport('/click/submitResume/Submit')
      this.resetFlag()
      if (this.position === 0) {
        this.checkFlag.position = true
        message.error('请补充职位信息')
        return
      } else {
        let postData = JSON.parse(JSON.stringify(this.modelData))
        postData.mail = postData.mail.trim()
        postData.phone = postData.phone.trim()
        let flag = 1
        postData['educations'][0].unifiedAdmission =
          postData['educations'][0].unifiedAdmission === 1
        postData.hasTeacherCertificate = postData.hasTeacherCertificate === 1
        for (let key in this.checkFlag) {
          if (typeof postData[key] === 'string') {
            if (postData[key].trim() === '') {
              this.checkFlag[key] = true
              flag = 0
            }
          }
        }

        for (let key in this.educationFlag) {
          if (key === 'startDate' || key === 'endDate') {
            if (
              moment(postData['educations'][0][key]).format('YYYY-MM') ===
                'Invalid date' ||
              postData['educations'][0][key] === null ||
              postData['educations'][0][key].trim() === ''
            ) {
              postData['educations'][0][key] = ''
            } else {
              postData['educations'][0][key] = moment(
                postData['educations'][0][key],
              ).format('YYYY-MM')
            }
          } else {
            if (typeof postData['educations'][0][key] === 'string') {
              if (postData['educations'][0][key].trim() === '') {
                this.educationFlag[key] = true
                flag = 0
              }
            }
          }
        }

        if (postData.mail !== '' && !isEmail(postData.mail)) {
          this.checkFlag['mail'] = true
          message.error('邮箱不合法，请再次确认')
          return
        }

        if (postData.phone !== '' && !isMobile(postData.phone)) {
          this.checkFlag['phone'] = true
          message.error('手机号不合法，请再次确认')
          return
        }

        if (
          (postData['educations'][0].startDate !== '' ||
            postData['educations'][0].endDate !== '') &&
          compareTime(
            postData['educations'][0].startDate,
            postData['educations'][0].endDate,
          )
        ) {
          message.error('在校起止时间错误')
          return
        }

        if (flag === 1) {
          let channelData = {}
          if (this.keyfrom !== 'wx-recommend') {
            if (this.channelShowAll) {
              let channelFlag = this.checkChannel()
              if (!channelFlag) {
                return
              }
              channelData = {
                channel: this.channelJson['channel'],
                secChannelId: this.channelJson['secChannelId'],
                desc:
                  this.channelJson['channelSchool'] +
                  this.channelJson['recommand'],
                uploaderLdap: '',
              }
            } else {
              channelData = {
                channel: this.urlQuery['cl'],
                secChannelId: Number(this.urlQuery['sc']) || 5, //默认宣讲会
                desc: this.urlQuery['cd'] || '',
                uploaderLdap: '',
              }
            }
          } else {
            channelData = {
              channel: '推荐',
              secChannelId: 12, //辅导招聘增长,
              desc: this.userId,
              uploaderLdap: '',
            }
          }
          if (this.channelJson['channel'] === '外部推荐') {
            channelData.secChannelId = ''
            channelData.desc =
              this.channelJson.outerRecommandMobile +
              this.channelJson.outerRecommand
          }
          this.loadingResume = true
          let forms = new FormData()
          for (let i = 0; i < this.fileList.length; i++) {
            forms.append('files', this.fileList[i])
          }
          forms.append('resumeJson', JSON.stringify(postData))
          forms.append('positionIds', [this.position])
          forms.append('channelJson', JSON.stringify(channelData))
          try {
            let res = {}
            if (this.keyfrom !== 'wx-recommend') {
              res = await schoolUploadResume({ body: forms })
            } else {
              res = await uploadTutorResume({ body: forms })
            }
            if (res['code'] === 1) {
              this.visible = true
              this.frogReport('/event/submitResume/Success', [
                {
                  key: 'srId',
                  value: res['data'][0],
                },
              ])
            } else {
              message.error(res['msg'])
              this.frogReport('/event/submitResume/Fail')
            }
          } catch {}
          this.loadingResume = false
        } else {
          message.error('请补充完善信息')
        }
      }
    },
    async resolveResume() {
      let forms = new FormData()
      for (let i = 0; i < this.fileList.length; i++) {
        forms.append('file', this.fileList[i])
      }
      this.loadingResume = true
      this.resumeButtonTitle = '简历解析中'
      this.resumeButtonDisabled = true
      try {
        let res = await parseResume({ body: forms })
        this.resetFlag()
        if (res['code'] === 1) {
          res = res['data']
          res['hasTeacherCertificate'] = res['hasTeacherCertificate'] ? 1 : 0
          if (res['educations'].length > 0) {
            let topEducation = res['educations'][0]
            for (let key in topEducation) {
              if (key === 'startDate' || key === 'endDate') {
                if (
                  topEducation[key].trim() === '' ||
                  moment(topEducation[key]) === 'Invalid Date'
                ) {
                  topEducation[key] = null
                } else {
                  topEducation[key] = moment(topEducation[key])
                }
              } else {
                if (typeof topEducation[key] === 'boolean') {
                  topEducation[key] = topEducation[key] ? 1 : 0
                }
              }
            }
            res['educations'][0] = topEducation
          } else {
            res.educations = this.modelData.educations
          }
          this.modelData = res
        }
      } catch {}
      this.loadingResume = false
      this.resumeButtonDisabled = false
      this.resumeButtonTitle = '重新上传简历'
    },
    change(arg) {
      this.checkFlag[arg] = false
      if (arg === 'city') {
        this.jobs = [{ id: 0, name: '请选择' }]
        this.position = 0
        if (this.city !== 0) {
          this.queryPosition()
        }
      }
    },
    changeEducation(arg) {
      this.educationFlag[arg] = false
    },
    beforeUpload(file) {
      if (!this.acceptFileType.includes(file.type)) {
        message.error(
          '简历文件类型错误，支持WORD、PDF、PNG、JPG、JPEG、WPS等格式文件的上传',
        )
      } else if (file.size > 10485760) {
        message.error('简历大小超过10M，请重新上传')
      } else {
        this.fileList = [file]
        this.resolveResume()
      }
      return false
    },
    handleRemove(file) {
      if (this.loadingResume) {
        message.error('简历正在解析中，不能移出，请解析完成后操作')
      } else {
        const index = this.fileList.indexOf(file)
        const newFileList = this.fileList.slice()
        newFileList.splice(index, 1)
        this.fileList = newFileList
      }
    },
    resetFlag() {
      this.checkFlag = {
        name: false,
        mail: false,
        phone: false,
        position: false,
      }
      this.educationFlag = {
        major: false,
        university: false,
        startDate: false,
        endDate: false,
        degree: false,
      }
      this.channelFlag = {
        channel: false,
        secChannelId: false,
        recommand: false,
        channelSchool: false,
      }
    },
    changeChannel(arg) {
      this.channelFlag[arg] = false
      switch (arg) {
        case 'channel':
          this.channelJson.secChannelId = ''
          this.sceChannels = this.channels[this.channelJson.channel]
          if (this.channelJson.channel !== '内推') {
            this.channelJson.recommand = ''
          }
          if (this.channelJson.channel === '外部推荐') {
            this.channelJson.secChannelId = ''
            this.channelJson.channelSchool = ''
          } else {
            this.channelJson.outerRecommandMobile = ''
            this.channelJson.outerRecommand = ''
          }
          break
        case 'secChannelId':
          if (
            !this.schoolRecruitmentSecChannelIds.includes(
              this.channelJson['secChannelId'],
            )
          ) {
            this.channelJson.channelSchool = ''
          }
          break
        default:
          break
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.includes(input)
    },
    fetch(value, callback) {
      let data = []
      for (let key in this.channels[this.channelJson.channel]) {
        if (key.indexOf(value) !== -1) {
          data.push(key)
        }
      }
      callback(data)
    },
    checkChannel() {
      if (this.channelJson['channel'].trim() === '') {
        this.channelFlag['channel'] = true
        message.error('请选择渠道')
        return false
      } else if (
        this.channelJson['secChannelId'] === '' &&
        this.channelJson['channel'] !== '外部推荐'
      ) {
        this.channelFlag['secChannelId'] = true
        message.error('请选择二级渠道')
        return false
      } else if (
        this.schoolRecruitmentSecChannelIds.includes(
          this.channelJson['secChannelId'],
        ) &&
        this.channelJson['channelSchool'].trim() === ''
      ) {
        this.channelFlag['channelSchool'] = true
        message.error('请填写双选会/宣讲会学校')
        return false
      } else if (
        this.channelJson['channel'] === '内推' &&
        this.channelJson['recommand'].trim() === ''
      ) {
        this.channelFlag['recommand'] = true
        message.error('请填写内推人')
        return false
      } else if (this.channelJson['channel'] === '外部推荐') {
        if (this.channelJson['outerRecommand'].trim() === '') {
          this.channelFlag['outerRecommand'] = true
          message.error('请填写推荐人姓名')
          return false
        } else if (
          this.channelJson['outerRecommandMobile'].trim() === '' ||
          !isMobile(this.channelJson['outerRecommandMobile'])
        ) {
          this.channelFlag['outerRecommandMobile'] = true
          message.error('推荐人手机号不合法，请再次确认')
          return false
        }
        return true
      } else {
        return true
      }
    },
    resoveKeyfrom() {
      this.urlQuery = this.$route.query
      if (this.urlQuery.hasOwnProperty('web_keyfrom')) {
        if (this.urlQuery.web_keyfrom.indexOf('wx-recommend') > -1) {
          let keyfromDetail = this.urlQuery.web_keyfrom.split('-')
          this.keyfrom = 'wx-recommend' // 辅导招聘增长
          this.userId = keyfromDetail[2] == undefined ? '' : keyfromDetail[2]
        } else {
          this.keyfrom = this.urlQuery.web_keyfrom
          this.userId = ''
        }
      } else {
        this.keyfrom = 'xx-qrcode' // 校招二维码
        this.userId = ''
      }
      if (
        this.urlQuery.hasOwnProperty('cl') &&
        this.urlQuery.cl.trim() !== ''
      ) {
        this.channelShowAll = false
      }
    },
    frogReport(url, extra = []) {
      // 招聘活动页外链
      const subRecommend = this.urlQuery.subR ? `-${this.urlQuery.subR}` : ''
      this.$addFrog(1531, url, [
        { key: 'keyfrom', value: `${this.keyfrom}${subRecommend}` },
        { key: 'recommendId', value: this.userId },
        ...extra,
      ])
    },
  },
}
</script>
<style lang="less">
.success-modal-wrap {
  .ant-modal {
    max-width: 375px;
    .ant-modal-body {
      text-align: center;
      padding: 0;
      img {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.blacklist-warring {
  max-width: 390px;
  padding: 0 45px;
  text-align: center;
  height: 100vh;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2em;
  img {
    width: 100%;
  }
}
.uploads {
  :global {
    & /deep/ .ant-upload-select {
      width: 100%;
    }
  }
}
.form-content {
  margin-top: 1em;
}
.btn-default,
.btn-default:active,
.btn-default:visited {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  color: #ff6600;
  border: 0px;
  outline: none;
}

.btn-success:hover {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  color: #ff6600;
}
.btn-submit,
.btn-submit:active,
.btn-submit:visited {
  background-color: #ff6600;
  border-color: #ff6600;
  color: #ffffff;
  border: 0px;
}
.btn-submit:hover {
  background-color: #ff6600;
  border-color: #ff6600;
  color: #ffffff;
}
.tip {
  margin-top: 10px;
  color: #999;
}
.error {
  border: 1px solid red;
  border-radius: 4px;
}
.recommend {
  position: fixed;
  right: 6.25%;
  z-index: 200;
  cursor: pointer;
  background: rgba(255, 102, 0, 1);
  border-radius: 18px;
  top: 0.32rem;
  outline: none;
  border: 0px;
  color: rgba(255, 255, 255, 1);
  a {
    height: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
  }
}
.recommend:active,
.recommend:visited {
  outline: none;
  border: none;
}
.exceed-text {
  text-align: center;
  font-size: 0.16rem;
  padding-top: 0.8rem;
}
.logo-block-wrap {
  display: flex;
  align-items: center;
}
</style>
